import ActionCreator from "../../actionCreator";

export default {
    nextStep: ActionCreator("NEXT"),
    prevStep: ActionCreator("PREV"),
    register: ActionCreator("REGISTER"),
    setStep: ActionCreator("SET_STEP"),
    errorResponse: ActionCreator("ERROR_RESPONSE_REGISTER"),
    reset: ActionCreator("REGISTER_RESET"),
};
